<template>
    <div class="short-to-close-statement" v-if="product.totalAvailableProceeds < 0 && textStrings.hideShortToCloseGraphs == true">

      <h2 class="short-to-close-headline" v-html="textStrings.shortToCloseStatement.headline">
      </h2>
      <h3 class="short-to-close-text" v-html="textStrings.shortToCloseStatement.text">
      </h3>
    </div>
    <div class="product-graph" v-if="product.totalAvailableProceeds >= 0 || textStrings.hideShortToCloseGraphs !== true">
      <ProceedsChart :proceedsChartData="proceedsChartData" />
    </div>
    <div class="product-details">
      <ProductDetails :product="product" :youngestBorrower="borrower.age" :creditGrowth="creditGrowth"  :textStrings="textStrings" />
      <Transition name="fade">
        <div class="projected-credit-growth" v-if="showGrowthChart" >
          <CreditGrowthChart :growthData="creditGrowthData" :product="product" :textStrings="textStrings" />
        </div>
      </Transition>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import ProceedsChart from './ProceedsChart.vue'
import CreditGrowthChart from './CreditGrowthChart.vue'
import ProductDetails from './ProductDetails.vue'
import { fetchBaselinePrincipleGrowth } from '../inc/baseline.js'
import { getCreditGrowth, getPrincipleLimitGrowth, getXLabels, chartDataVar } from '../inc/growthChart.js'

export default defineComponent({
  name: 'HECMResults',
  inheritAttrs: false,
  components: { ProceedsChart, CreditGrowthChart, ProductDetails },
  props: {
    product: Object,
    borrower: Object,
    textStrings: Object
  },
  data () {
    return {
      creditGrowth: Number,
      creditGrowthData: Object,
      showGrowthChart: false
    }
  },
  setup (props) {
    const creditGrowthAge = (props.borrower.age + 20)
    const procceedsValue = (props.product.totalAvailableProceeds < 0) ? 'negative' : 'positive'
    let proceedsChartData = []
    // eslint-disable-next-line vue/no-setup-props-destructure
    proceedsChartData = props.product.proceedsChartOptions[procceedsValue]
    // eslint-disable-next-line vue/no-setup-props-destructure
    const pcd = props.product.proceedsChartData[procceedsValue]
    proceedsChartData.data = []
    for (const key in pcd) {
      proceedsChartData.data.push(Math.abs(props.product[pcd[key]]))
    }
    return { proceedsChartData, creditGrowthAge }
  },
  mounted () {
    if (this.product.growthChartOptions.showGrowthChart === true && this.product.totalAvailableProceeds >= this.product.growthChartOptions.min) {
      fetchBaselinePrincipleGrowth(
        this.product.marginUsed,
        this.product.totalAvailableProceeds,
        this.borrower.age
      )
        .then((response) => {
          const data = response
          this.creditGrowth = getCreditGrowth(data.principallimitgrowtharray)
          const formattedChartData = chartDataVar
          formattedChartData.labels = getXLabels(this.borrower.age)
          formattedChartData.datasets[0].labels = getXLabels(this.borrower.age)
          formattedChartData.datasets[0].data = getPrincipleLimitGrowth(data.principallimitgrowtharray)
          this.creditGrowthData = formattedChartData
          this.showGrowthChart = true
        })
        .catch((error) => {
          console.error('Error fetching data', error)
        })
    }
  }
})
</script>
